/* RELAXIM REBUILD スマホメニュー JS（2026-05-07）
 *
 * 仕様：
 * - Crave テーマの <header-drawer> 内 <summary> クリックを capture phase で intercept
 * - 既存 .menu-drawer は CSS で display:none しているため、新規 #rx-mobile-menu を開閉する
 * - body に rx-menu-locked クラス付与でスクロールロック
 * - ESC キー / 閉じるボタン / 内部リンククリックで閉じる
 * - PC（990px以上）では何もしない（PCナビが既にある）
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var menu = document.getElementById('rx-mobile-menu');
    if (!menu) return;

    var closeBtn = menu.querySelector('.rx-mobile-menu__close');
    var nav = menu.querySelector('.rx-mobile-menu__nav');

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function openMenu() {
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('rx-menu-locked');
      var summaries = document.querySelectorAll('header-drawer summary');
      summaries.forEach(function (s) { s.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 50);
    }

    function closeMenu() {
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('rx-menu-locked');
      var summaries = document.querySelectorAll('header-drawer summary');
      summaries.forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
      var details = document.querySelectorAll('header-drawer details[open], #Details-menu-drawer-container[open]');
      details.forEach(function (d) {
        try { d.removeAttribute('open'); d.classList.remove('menu-opening'); } catch (e) {}
      });
    }

    function toggleMenu() {
      if (menu.getAttribute('aria-hidden') === 'false') closeMenu();
      else openMenu();
    }

    document.addEventListener('click', function (e) {
      if (!isMobile()) return;
      var target = e.target;
      if (!target) return;

      var summary = target.closest && target.closest('header-drawer summary, summary.header__icon--menu');
      if (summary) {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu();
        return;
      }

      if (target.closest && target.closest('.rx-mobile-menu__close')) {
        e.preventDefault();
        closeMenu();
        return;
      }

      if (target.closest && target.closest('.rx-mobile-menu__nav a')) {
        closeMenu();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      }
    });

    var mq = window.matchMedia('(min-width: 990px)');
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches) closeMenu(); });
    else if (mq.addListener) mq.addListener(function (e) { if (e.matches) closeMenu(); });

    try {
      var current = window.location.pathname;
      var links = nav ? nav.querySelectorAll('a') : [];
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href === current || (href !== '/' && current.indexOf(href) === 0)) {
          a.classList.add('is-current');
        }
      });
    } catch (e) {}
  });
})();
